import { connect } from "react-redux";
import styled, { keyframes } from "styled-components";
import React from "react";
import { UsersThree } from "@phosphor-icons/react";

import ProfileBox from "./ProfileBox";

const ProfileList = ({ profiles }) => {
  if (!profiles) {
    return (
      <Grid aria-busy="true" aria-label="Loading profiles">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i}>
            <div className="photo" />
            <div className="line w60" />
            <div className="line w40" />
            <div className="line w80" />
          </Skeleton>
        ))}
      </Grid>
    );
  }

  if (profiles.length === 0) {
    return (
      <Empty>
        <UsersThree size={44} weight="duotone" />
        <h3>No matching profiles found</h3>
        <p>Try widening the age range or choosing "Any" for caste.</p>
      </Empty>
    );
  }

  return (
    <Grid>
      {profiles.map((profile, i) => (
        <ProfileBox key={profile.uid} profile={profile} index={i} />
      ))}
    </Grid>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 24px;

  @media (max-width: 520px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
`;

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`;

const Skeleton = styled.div`
  border-radius: var(--radius-card);
  background: var(--surface);
  border: 1px solid var(--border);
  padding: 0 0 20px;
  overflow: hidden;

  .photo,
  .line {
    background: linear-gradient(90deg, var(--surface-tint) 0%, var(--border) 50%, var(--surface-tint) 100%);
    background-size: 200% 100%;
    animation: ${shimmer} 1.6s ease-in-out infinite;
  }

  .photo {
    aspect-ratio: 4 / 5;
    margin-bottom: 16px;
  }

  .line {
    height: 12px;
    border-radius: 6px;
    margin: 10px 16px 0;
  }

  .w40 { width: 40%; }
  .w60 { width: 60%; }
  .w80 { width: 80%; }
`;

const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 56px 24px;
  border-radius: var(--radius-card);
  border: 1.5px dashed var(--border-strong);
  color: var(--text-muted);

  svg {
    color: var(--coral);
    margin-bottom: 12px;
  }

  h3 {
    font-size: 22px;
  }

  p {
    margin: 0;
  }
`;

const mapStateToProps = (state) => ({
  profiles: state.profileState.searchResults,
});

export default connect(mapStateToProps)(ProfileList);
